import { KeycloakContext } from '@laborability/components';
import { useContext, useEffect } from 'react';

export default function Logout() {
  const { keycloak } = useContext(KeycloakContext);

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('login');
    keycloak?.logout({ redirectUri: window.location.origin });
  }, []);

  return null;
}
